import React from 'react';
import PropTypes from 'prop-types';
import SimpleButton from '../components/atoms/SimpleButton';
import { connect } from 'react-redux';
import ReactTimeout from 'react-timeout';
import { contentChange } from '../actions/content';

 
class SectionIncomplete extends React.Component {
    constructor(props) {
      super(props);
      this.goBack = this.goBack.bind(this);
      this.prepareGoBack = this.prepareGoBack.bind(this);
      this.state = {back: false};
    }
    goBack() {
      let link = this.props.section.link;
      this.props.dispatch(contentChange(link));
    }
    prepareGoBack(evt) {
      if(this.state.back) {
        return;
      }
      this.setState({ back:true });
      this.props.setTimeout(this.goBack, 300);
    }
    componentWillUpdate(nextProps, nextState) {
      if(!nextProps.section.isActive && this.state.back) {
        this.setState({ back:false });
      }
    }

    render () {
        return (
            <div id="sectionincomplete" className={`${this.props.section.isActive?"active":"inactive"} ${this.state.back?"dissolve":""}`}>
              <div className="overlayinner">
              <h4>{this.props.headline}</h4>
              <SimpleButton children={this.props.section.label} onClick={(evt) => this.prepareGoBack(evt)} />
              </div>
            </div>
        );
    }

}


SectionIncomplete.propTypes = {
  headline: PropTypes.string
}

SectionIncomplete.defaultProps = {
  headline: "Hinweis: Ein vorheriger Schritt wurde nicht korrekt vervollständigt."
}

const mapStateToProps = (state) => {
  return {
    section: state.section
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch: dispatch
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ReactTimeout(SectionIncomplete));


// WEBPACK FOOTER //
// ./src/utils/SectionIncomplete.js